/* DEPRECATED - backward compatibility only */
export abstract class Assignable {
    constructor(properties: any) {
        Object.keys(properties).forEach((key: any) => {
            (this as any)[key] = properties[key];
        });
    }
}
